import { useState, useCallback } from 'react';
var focusableElementSelectors = [
    'input',
    'a',
    'button',
    '[tabindex]',
    'select',
    'textarea',
    'details',
    'a[href]',
];
var focusableElementSelector = focusableElementSelectors.join(',');
var getFocusableElements = function (parent) {
    var focusableInnerElements = Array.from(parent.querySelectorAll(focusableElementSelector));
    var isElementFocusable = parent.hasAttribute('tabindex') ||
        focusableElementSelectors.includes(parent.tagName.toLowerCase());
    return isElementFocusable ? focusableInnerElements.concat([parent]) : focusableInnerElements;
};
var clearTabIndexes = function (carouselInnerElement, initialTabIndexes) {
    var elements = getFocusableElements(carouselInnerElement);
    elements.forEach(function (el, index) {
        var _a, _b;
        if (!initialTabIndexes[index]) {
            el.removeAttribute('tabindex');
            el.classList.remove('noClick');
            if ((_a = el.classList) === null || _a === void 0 ? void 0 : _a.contains('tooltipButton')) {
                (_b = el.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('close');
            }
            return;
        }
        el.setAttribute('tabindex', initialTabIndexes[index]);
    });
};
var useForceFocus = function () {
    var _a = useState([]), initialTabIndexes = _a[0], setInitialTabIndexes = _a[1];
    var memoriseTabIndexes = useCallback(function (itemsContainer) {
        if (initialTabIndexes.length) {
            clearTabIndexes(itemsContainer, initialTabIndexes);
        }
        var allElements = getFocusableElements(itemsContainer);
        var newTabIndexes = allElements.map(function (t) { return t.getAttribute('tabindex') || ''; });
        if (newTabIndexes.length !== initialTabIndexes.length ||
            newTabIndexes.some(function (tabIndex, i) { return tabIndex !== initialTabIndexes[i]; })) {
            setInitialTabIndexes(newTabIndexes);
        }
    }, [initialTabIndexes]);
    var forceCurrentSlideFocus = useCallback(function (itemsContainer, visibleElements) {
        if (!initialTabIndexes.length)
            return;
        clearTabIndexes(itemsContainer, initialTabIndexes);
        var carouselItems = itemsContainer.children;
        Array.from(carouselItems).forEach(function (item, itemIndex) {
            if (!visibleElements.includes(itemIndex)) {
                var elements = getFocusableElements(carouselItems[itemIndex]);
                elements.forEach(function (el) {
                    var _a, _b;
                    el.setAttribute('tabindex', '-1');
                    el.classList.add('noClick');
                    /**
                     * Logic for Tooltip inside ProductPod be closed if element is not visible
                     * For more information: src/ingredients/ProductPod/TooltipWrapper/index.tsx
                     */
                    if ((_a = el.classList) === null || _a === void 0 ? void 0 : _a.contains('tooltipButton'))
                        (_b = el.parentElement) === null || _b === void 0 ? void 0 : _b.classList.add('close');
                });
            }
        });
    }, [initialTabIndexes]);
    return {
        memoriseTabIndexes: memoriseTabIndexes,
        forceCurrentSlideFocus: forceCurrentSlideFocus,
    };
};
export default useForceFocus;
//# sourceMappingURL=useForceFocus.js.map